var _path, _circle, _circle2, _path2, _circle3, _circle4, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoblanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9334 0.275427C16.4632 -0.0255628 17.1109 -0.0311828 17.6458 0.260574L25.0462 4.29718L24.0348 6.15143L16.8064 2.20868L2.36289 10.4152V16.7714L16.2713 8.73549L16.7996 9.64991L16.2713 8.73549C16.811 8.42367 17.4753 8.42053 18.0179 8.72722L25.2417 12.8103L32.1132 8.88371L33.1611 10.7176L26.116 14.7434C25.5774 15.0511 24.9166 15.0527 24.3766 14.7475L17.1537 10.665L2.89142 18.9054C1.718 19.5834 0.250732 18.7366 0.250732 17.3814V10.2104C0.250732 9.5772 0.590823 8.99282 1.14134 8.68002L15.9334 0.275427ZM25.068 12.9095C25.0683 12.9094 25.0686 12.9092 25.0689 12.909L25.068 12.9095Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9332,
    cy: 9.80067,
    r: 2.46418,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.8926,
    cy: 5.57636,
    r: 2.46418,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0666 36.9272C18.5368 37.2282 17.8891 37.2338 17.3542 36.9421L9.95376 32.9055L10.9652 31.0512L18.1936 34.994L32.6371 26.7874V20.4312L18.7287 28.4671L18.2004 27.5527L18.7287 28.4672C18.189 28.779 17.5247 28.7821 16.9821 28.4754L9.75827 24.3924L2.88683 28.3189L1.83891 26.4851L8.88405 22.4593C9.42261 22.1515 10.0834 22.15 10.6234 22.4552L17.8463 26.5377L32.1086 18.2972C33.282 17.6192 34.7493 18.466 34.7493 19.8212V26.9923C34.7493 27.6254 34.4092 28.2098 33.8587 28.5226L19.0666 36.9272ZM9.93197 24.2931C9.93169 24.2933 9.93142 24.2934 9.93114 24.2936L9.93197 24.2931Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.06707,
    cy: 27.402,
    r: 2.46418,
    transform: "rotate(180 3.06707 27.402)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1074,
    cy: 31.6263,
    r: 2.46418,
    transform: "rotate(180 10.1074 31.6263)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7899 17.8501L17.7127 15.9943C17.4979 15.8648 17.2305 15.8593 17.0106 15.9798L13.6237 17.8367C13.1523 18.0951 13.1328 18.7652 13.5884 19.0507L16.9735 21.1717C17.2116 21.3209 17.5156 21.3143 17.7469 21.1548L20.8259 19.0327C21.247 18.7425 21.2279 18.1142 20.7899 17.8501Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.11216
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoblanc);
export default __webpack_public_path__ + "static/media/logo blanc.d01169fa1f912a04934015be7364ffed.svg";
export { ForwardRef as ReactComponent };